import { Component, HostBinding, Input } from '@angular/core'
import { AbstractControl } from '@angular/forms'

@Component({
  selector: 'bdg-error-field',
  templateUrl: './error-field.component.html',
  styleUrls: ['./error-field.component.scss'],
})
export class ErrorFieldComponent {
  @Input()
  showIcon = true

  @Input()
  control: AbstractControl

  @HostBinding('class') classes = 'd-inline-block'
  get canRenderIcon() {
    return this.showIcon
  }

  get errorMessage() {
    return this.control.errors ? Object.values(this.control.errors)[0] : null
  }

  get canRender() {
    return this.control && this.control.invalid && (this.control.dirty || this.control.touched)
  }
}
